import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { mapState, mapGetters, mapMutations } from 'vuex';
import Konva from 'konva';
let _ = require('lodash');
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
const {
  pickEditorStyle,
  normalizeAssetUrl
} = require('./componentEditorData');
export default {
  name: 'mapv2assembly',
  meta: {
    title: ''
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: {}
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    stageWidth: {
      type: Number,
      default: 0
    },
    stageHeight: {
      type: Number,
      default: 0
    }
  },
  emits: ['hide', 'addNode', 'selectNode', 'savetrEndNode', 'changestyle', 'deleteNode'],
  components: {},
  data() {
    return {
      stage: '',
      editlayer: '',
      tr: '',
      cnode: '',
      // elemInfo: {},
      // defaultpicImg: require('@/assets/mapv2/defaultImage.jpg'),
      defaultpicImg: 'https://p.cldisk.com/star3/origin/bcf319ee85abda331c2cae8b0ac6e71b.jpg',
      mainStyle: {
        width: '',
        height: ''
      },
      toolslayer: '',
      toolsList: {
        delete: {
          name: '删除',
          image: require('@/assets/icon/delete.png')
        }
      },
      id: 0
    };
  },
  created() {},
  computed: {
    ...mapGetters(['mapv2info'])
  },
  mounted() {
    this.$nextTick(() => {
      console.log(`domeditorvalue`, this.value);
      this.syncNextId(this.value);
      this.drawData(this.value);
    });
  },
  watch: {
    'mapv2info.domstyle': {
      handler(val) {
        if (val) this.changeNodeStyle(val);
      },
      deep: true
    },
    isMobile: {
      handler() {
        this.applyStageSize();
      },
      immediate: true
    },
    show(val) {
      if (val) this.$nextTick(() => this.applyStageSize());
    },
    stageWidth() {
      this.$nextTick(() => this.applyStageSize());
    },
    stageHeight() {
      this.$nextTick(() => this.applyStageSize());
    }
  },
  methods: {
    ...mapMutations(['SET_MAPFORMITEM']),
    getStageSize() {
      if (this.isMobile) return {
        width: 375,
        height: 667
      };
      return {
        width: window.innerWidth,
        height: window.innerHeight
      };
    },
    syncNextId(list) {
      const ids = (Array.isArray(list) ? list : []).map(item => Number(item && item.id)).filter(n => !Number.isNaN(n));
      this.id = (ids.length ? Math.max(...ids) : -1) + 1;
    },
    ensureUniqueNodeIds(data) {
      if (!Array.isArray(data)) return;
      const seen = new Set();
      let next = 0;
      data.forEach(item => {
        const key = String(item.id);
        if (item.id === undefined || item.id === null || seen.has(key)) {
          while (seen.has(String(next))) next++;
          item.id = next;
          if (item.style) item.style.id = next;
        }
        seen.add(String(item.id));
        const num = Number(item.id);
        if (!Number.isNaN(num)) next = Math.max(next, num + 1);
      });
    },
    applyStageSize() {
      const {
        width,
        height
      } = this.getStageSize();
      if (this.isMobile) {
        this.mainStyle = {
          width: '375px',
          height: '667px'
        };
      } else {
        this.mainStyle = {
          width: width + 'px',
          height: height + 'px'
        };
      }
      if (!this.stage || this.stage === '') return;
      this.stage.width(width);
      this.stage.height(height);
      this.stage.scale({
        x: 1,
        y: 1
      });
      this.stage.draw();
    },
    /**
     * 创建舞台
     */
    initStage() {
      const {
        width,
        height
      } = this.getStageSize();
      this.stage = new Konva.Stage({
        container: document.querySelector('#DOMEditor'),
        width: width,
        height: height,
        draggable: false
      });
      // 修改类名
      let contentContainer = this.stage.content;
      contentContainer.className = 'stage-content';
      this.stage.on('click tap', e => {
        this.stageClick(e);
      });
      this.editlayer = new Konva.Layer();
      this.stage.add(this.editlayer);
      this.createtoolsLayer();
      this.createTranformer();
    },
    /**
     * 创建工具栏图层
     */
    createtoolsLayer() {
      let that = this;
      const toolsWidth = 28;
      this.toolslayer = new Konva.Layer();
      this.stage.add(this.toolslayer);
      let group = new Konva.Group({
        x: 100,
        y: 100,
        height: toolsWidth,
        name: 'tools'
      });
      const groupbg = new Konva.Rect({
        x: 0,
        y: 0,
        width: Object.keys(this.toolsList).length * toolsWidth + 10,
        height: toolsWidth + 4,
        fill: '#ffffff',
        shadowColor: 'rgba(0, 0, 0, 0.05)',
        shadowBlur: 8,
        cornerRadius: 4
      });
      group.add(groupbg);
      Object.keys(this.toolsList).forEach((tool, index) => {
        const imagegroup = new Konva.Group({
          x: toolsWidth * index + 5,
          y: 2,
          width: toolsWidth,
          height: toolsWidth
        });
        const imagebg = new Konva.Rect({
          x: 0,
          y: 0,
          width: toolsWidth,
          height: toolsWidth,
          fill: '#ffffff',
          cornerRadius: 4,
          name: `${tool}bg`
        });
        imagegroup.add(imagebg);
        let konvanode;
        const imageObj = new Image();
        imageObj.src = this.toolsList[tool].image;
        konvanode = new Konva.Image({
          x: 4,
          y: 4,
          width: 20,
          height: 20,
          image: imageObj,
          name: tool
        });
        konvanode.on('click', e => {
          console.log(`konvanode.click`, e);
          e.cancelBubble = true;
          that[`${e.target.getAttr('name')}Handle`](e);
        });
        konvanode.on('mouseenter', e => {
          console.log(`konvanode.mouseenter`, e);
          let name = e.target.getAttr('name');
          e.target.parent.find(`.${name}bg`)[0].setAttr('fill', '#f2f2f2');
          document.body.style.cursor = 'pointer';
        });
        konvanode.on('mouseout', e => {
          console.log(`konvanode.mouseout`, e);
          let name = e.target.getAttr('name');
          e.target.parent.find(`.${name}bg`)[0].setAttr('fill', '#ffffff');
          document.body.style.cursor = '';
        });
        imagegroup.add(konvanode);
        group.add(imagegroup);
      });
      this.toolslayer.add(group);
      this.toolslayer.hide();
      this.toolslayer.draw();
    },
    /**
     * 创建变换器
     */
    createTranformer() {
      let that = this;
      // new transformer
      this.tr = new Konva.Transformer({
        rotateEnabled: false,
        // 禁止旋转
        keepRatio: false,
        // 保持比例
        enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
        anchorStroke: '#1261FF',
        anchorFill: '#ffffff',
        anchorSize: 5,
        borderStroke: '#08A1EF',
        borderDash: [3, 3],
        name: 'transformer'
      });
      this.editlayer.add(this.tr);
      /* bind events to the Transformer. You can use events: transform, transformstart, transformend, dragstart, dragmove, dragend */
      this.tr.on('transformstart', e => {
        that.nodeChange(e);
      });
      this.tr.on('transform', e => {
        that.nodeChange(e);
      });
      this.tr.on('transformend', e => {
        that.nodeChange(e);
      });
      this.tr.on('dragstart', e => {
        that.nodeChange(e);
      });
      this.tr.on('dragmove', e => {
        that.nodeChange(e);
      });
      this.tr.on('dragend', e => {
        that.nodeChange(e);
      });
    },
    /**
     * 舞台点击事件
     */
    stageClick(e) {
      console.log('点击stage', e);
      console.log(`this.tr`, this.tr);
      /* 点击stage 重置参数 */
      if (_.isEqual(e.target, this.stage)) {
        this.editlayer.getChildren().forEach(item => {
          item.setAttr('draggable', false);
        });
        this.tr.nodes([]);
        /* 点击stage 空白区域时 隐藏dom编辑器 */
        console.log('点击stage 空白区域时 隐藏dom编辑器');
        this.$emit('hide', false);
        return;
      }

      // do nothing if clicked NOT on our rectangles
      if (e.target.getParent().getType() === 'Group' && e.target.getParent().hasName('tools')) {
        console.log(222);
        // this.tr.nodes([])
        return;
      }
      const metaPressed = e.evt.shiftKey || e.evt.ctrlKey || e.evt.metaKey;
      const isSelected = this.tr.nodes().indexOf(e.target) >= 0;
      if (this.editlayer.getChildren().length > 0) {
        this.editlayer.getChildren().forEach(child => {
          child.setAttr('draggable', false);
        });
      }
      if (!metaPressed && !isSelected) {
        e.target.setAttr('draggable', true);
        this.tr.nodes([e.target]);
      } else if (metaPressed && isSelected) {
        const nodes = this.tr.nodes().slice();
        nodes.splice(nodes.indexOf(e.target), 1);
        this.tr.nodes(nodes);
      } else if (metaPressed && !isSelected) {
        const nodes = this.tr.nodes().concat([e.target]);
        this.tr.nodes(nodes);
      }
      this.tr.moveToTop();
      this.editlayer.batchDraw();
      this.nodeChange(true);
    },
    /**
     * 绘制初始数据
     */
    drawData(data) {
      if (this.stage === '') this.initStage();
      this.applyStageSize();
      this.removeImageNodes();
      const list = Array.isArray(data) ? data : [];
      this.ensureUniqueNodeIds(list);
      this.syncNextId(list);
      if (list.length > 0) {
        list.forEach(item => {
          if (item.type !== 'Image') return;
          const imageObj = new Image();
          const style = pickEditorStyle(item.style);
          const src = normalizeAssetUrl(item.image && item.image[0] && item.image[0].fileUrl ? item.image[0].fileUrl : this.defaultpicImg);
          const konvanode = new Konva.Image({
            ...style,
            id: item.id,
            image: imageObj,
            draggable: false
          });
          this.bindImageNodeEvents(konvanode);
          this.editlayer.add(konvanode);
          imageObj.onload = () => {
            this.editlayer.draw();
          };
          imageObj.src = src;
        });
      }
      this.tr.moveToTop();
      this.editlayer.batchDraw();
    },
    removeImageNodes() {
      if (!this.editlayer || typeof this.editlayer.find !== 'function') return;
      this.editlayer.find('Image').forEach(node => node.destroy());
      if (this.tr) this.tr.nodes([]);
    },
    /**
     * 新增node操作
    * @param {String} type 类型
     */
    addNode(val) {
      if (this.stage === '') this.initStage();
      this.applyStageSize();
      if (this.editlayer.getChildren().length > 0) {
        this.editlayer.getChildren().forEach(child => {
          if (!(child instanceof Konva.Transformer)) child.setAttr('draggable', false);
        });
      }
      let konvanode;
      if (val.type === 'Image') {
        const imageObj = new Image();
        konvanode = new Konva.Image({
          id: this.id,
          x: val.x,
          y: val.y,
          width: 90,
          height: 90,
          image: imageObj,
          draggable: true
        });
        this.bindImageNodeEvents(konvanode);
        imageObj.onload = () => {
          this.editlayer.draw();
        };
        imageObj.src = this.defaultpicImg;
      }
      this.id++;
      this.editlayer.add(konvanode);
      this.tr.nodes([konvanode]);
      this.tr.moveToTop();
      this.editlayer.batchDraw();
      this.nodeChange();
    },
    bindImageNodeEvents(konvanode) {
      if (!konvanode) return;
      konvanode.on('dragmove', e => {
        this.nodeChange(e);
      });
      konvanode.on('dragend', e => {
        this.nodeChange(e);
      });
      konvanode.on('transformend', e => {
        this.nodeChange(e);
      });
    },
    getLiveNodePayload(node) {
      const style = pickEditorStyle({
        id: node.id(),
        x: node.x(),
        y: node.y(),
        width: node.width(),
        height: node.height(),
        scaleX: node.scaleX(),
        scaleY: node.scaleY()
      });
      return {
        id: node.id(),
        type: node.getClassName(),
        style
      };
    },
    /**
     * 变形器触发事件
     */
    nodeChange(e) {
      console.log(`------ 变形器触发事件 -------`);
      console.log(e);
      console.log(`this.tr`, this.tr.nodes());
      const node = this.tr.nodes()[0];
      if (!node) return;
      this.SET_MAPFORMITEM({
        centerflag: true
      });
      const payload = this.getLiveNodePayload(node);
      console.log(`id`, payload.id);
      if (e === undefined) {
        console.log(`新增node`);
        let dragNode = {
          id: payload.id,
          type: payload.type,
          style: payload.style,
          flag: false,
          data: {}
        };
        if (payload.type === 'Image') {
          const image = node.getAttr('image');
          dragNode.image = [{
            fileUrl: image && image.src ? image.src : this.defaultpicImg
          }];
        }
        this.$emit('addNode', dragNode);
      } else {
        console.log(`编辑node`);
        this.$emit('selectNode', payload);
        if (e.type === 'dragend' || e.type === 'transformend') {
          this.$emit('savetrEndNode', payload);
        }
      }
      let tools = this.toolslayer.find('.tools');
      tools[0].setAttr('x', payload.style.x);
      tools[0].setAttr('y', payload.style.y - tools[0].getAttr('height') - 8);
      this.toolslayer.show();
      this.toolslayer.draw();
    },
    /**
     * map点击node触发事件
     */
    selectNode(val) {
      console.log(`selectNode`, val);
      console.log(`this.editlayer`, this.editlayer.getChildren());
      this.editlayer.getChildren().forEach(child => {
        child.setAttr('draggable', false);
        console.log(`child.getAttr('id')`, child.getAttr('id'));
        if (String(child.getAttr('id')) === String(val.id)) {
          child.setAttr('draggable', true);
          this.tr.nodes([child]);
          this.editlayer.batchDraw();
          this.nodeChange(true);
        }
      });
    },
    /* domeditor右侧内容管理 改变值触发 */
    changeNodeStyle(val) {
      console.log(`------ domeditor右侧内容管理 改变值触发 -------`);
      let cnode = this.tr.nodes()[0];
      if (!cnode) return;
      if (val.width !== undefined) {
        Object.keys(val).forEach(key => {
          cnode.setAttr(key, val[key]);
        });
        cnode.setAttr('scaleX', 1);
        cnode.setAttr('scaleY', 1);
      }
      if (val.image !== undefined) {
        const hasFile = Array.isArray(val.image) && val.image.length > 0 && val.image[0] && val.image[0].fileUrl;
        const imageObj = new Image();
        const src = hasFile ? val.image[0].fileUrl : this.defaultpicImg;
        const imagearr = hasFile ? val.image : [{
          fileUrl: this.defaultpicImg
        }];
        const boxW = Math.max(1, Math.round(cnode.width() * (cnode.scaleX() || 1)));
        const boxH = Math.max(1, Math.round(cnode.height() * (cnode.scaleY() || 1)));
        imageObj.onload = () => {
          let nextW = boxW;
          let nextH = boxH;
          if (hasFile && imageObj.width && imageObj.height) {
            const ratio = imageObj.width / imageObj.height;
            nextW = boxW;
            nextH = boxW / ratio;
            if (nextH > boxH) {
              nextH = boxH;
              nextW = boxH * ratio;
            }
          }
          cnode.setAttr('width', nextW);
          cnode.setAttr('height', nextH);
          cnode.setAttr('scaleX', 1);
          cnode.setAttr('scaleY', 1);
          cnode.image(imageObj);
          this.editlayer.draw();
          cnode.imagearr = imagearr;
          this.$emit('changestyle', cnode);
        };
        imageObj.src = src;
        return;
      }
      if (val.url !== undefined) {
        cnode.link = val;
      }
      this.$emit('changestyle', cnode);
    },
    /* domeditor重置数据 */
    resetNode(data) {
      const list = Array.isArray(data) ? data : [];
      if (this.tr) this.tr.nodes([]);
      this.removeImageNodes();
      if (this.toolslayer && this.toolslayer !== '') {
        this.toolslayer.hide();
        this.toolslayer.draw();
      }
      this.syncNextId(list);
      this.drawData(list);
      this.$nextTick(() => this.applyStageSize());
    },
    /* 切换屏幕 */
    changeScreen(val) {
      this.applyStageSize();
    },
    deleteHandle(val) {
      console.log(`------ 删除当前节点 -------`);
      console.log(`val`, val);
      let cnode = this.tr.nodes()[0];
      console.log(`cnode`, cnode);
      let that = this;
      ElMessageBox.confirm('确定要删除么？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        that.editlayer.getChildren().forEach(child => {
          if (String(child.getAttr('id')) === String(cnode.getAttr('id'))) child.remove();
        });
        that.toolslayer.hide();
        that.toolslayer.draw();
        that.tr.nodes([]);
        that.editlayer.draw();
        console.log(`that.editlayer`, that.editlayer);
        that.$emit('deleteNode', cnode);
      }).catch(() => {});
    }
  }
};